import React from "react";

import {
  StepCircle,
  StepItem,
  StepLabel,
  StepLine,
  StepsWrapper
} from "./styles";

type BookingStepsIndicatorProps = {
    currentStep: number;
};

const steps = ["Выбор даты", "Выбор времени", "Контактные данные"];

export const BookingStepsIndicator: React.FC<BookingStepsIndicatorProps> = ({ currentStep }) => {
  return (
    <StepsWrapper>
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        const isPassed = currentStep > stepNumber;

        return (
          <StepItem key={stepNumber}>
            <StepCircle $active={isActive} $passed={isPassed}>
              {stepNumber}
            </StepCircle>
            {index < steps.length - 1 && <StepLine $filled={currentStep > stepNumber} />}
            <StepLabel $active={isActive} $passed={isPassed}>{label}</StepLabel>
          </StepItem>
        );
      })}
    </StepsWrapper>
  );
};
